import { withSuspense } from '@lib/common/hoc';
import { lazy } from 'react';

const ContentMappingSearchPage = withSuspense(lazy(() => import('./content-mapping-search')));
export default ContentMappingSearchPage;
